import { selectQueryString } from '../results';
import { selectEtazhiBlackFridayPromoOffersData } from './selectEtazhiBlackFridayPromoOffersData';
import { getEtazhiBlackFridayUri } from 'shared/utils/etazhiBlackFriday';

import type { IAppState } from 'shared/common/state';

export const selectEtazhiBlackFridaySerpLink = (state: IAppState): string => {
  const queryString = selectQueryString(state);
  const promoOffersData = selectEtazhiBlackFridayPromoOffersData(state);

  const link = getEtazhiBlackFridayUri({ queryString, jsonQueryString: promoOffersData?.jsonQueryString ?? '' });

  return link;
};
